import { useQuery } from "@tanstack/react-query";
import { useState } from "react";

import { listAuditLog } from "@/api/endpoints/audit";

function formatDate(iso: string): string {
  return new Date(iso).toLocaleString();
}

export function AuditPage() {
  const [actor, setActor] = useState("");
  const [action, setAction] = useState("");
  const [page, setPage] = useState(1);

  const query = useQuery({
    queryKey: ["audit-log", actor, action, page],
    queryFn: () => listAuditLog({ actor, action, page }),
  });

  const totalPages = query.data ? Math.max(1, Math.ceil(query.data.total / query.data.page_size)) : 1;

  return (
    <div className="flex flex-col gap-4">
      <div className="flex gap-3">
        <input
          placeholder="Filter by actor…"
          value={actor}
          onChange={(e) => {
            setActor(e.target.value);
            setPage(1);
          }}
          className="w-56 rounded-md border border-border bg-surface-2 px-3 py-2 text-sm text-text outline-none focus:border-accent"
        />
        <input
          placeholder="Filter by action…"
          value={action}
          onChange={(e) => {
            setAction(e.target.value);
            setPage(1);
          }}
          className="w-56 rounded-md border border-border bg-surface-2 px-3 py-2 text-sm text-text outline-none focus:border-accent"
        />
      </div>

      <div className="overflow-x-auto rounded-lg border border-border bg-surface">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-border text-left text-xs uppercase tracking-wide text-text-muted">
              <th className="px-4 py-3">When</th>
              <th className="px-4 py-3">Actor</th>
              <th className="px-4 py-3">Action</th>
              <th className="px-4 py-3">Target</th>
              <th className="px-4 py-3">Exit code</th>
              <th className="px-4 py-3">IP</th>
            </tr>
          </thead>
          <tbody>
            {query.data?.items.map((e) => (
              <tr key={e.id} className="border-b border-border last:border-0">
                <td className="px-4 py-3 text-text-muted">{formatDate(e.created_at)}</td>
                <td className="px-4 py-3 font-mono text-text">{e.actor_username}</td>
                <td className="px-4 py-3 font-mono text-accent">{e.action}</td>
                <td className="px-4 py-3 font-mono text-text-muted">{e.target ?? "—"}</td>
                <td className="px-4 py-3 tabular-nums text-text-muted">
                  {e.exit_code === null ? "—" : e.exit_code}
                </td>
                <td className="px-4 py-3 font-mono text-text-muted">{e.ip_address ?? "—"}</td>
              </tr>
            ))}
            {query.data?.items.length === 0 && (
              <tr>
                <td colSpan={6} className="px-4 py-8 text-center text-text-muted">
                  No matching audit entries.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {query.data && totalPages > 1 && (
        <div className="flex items-center gap-3 text-sm text-text-muted">
          <button disabled={page <= 1} onClick={() => setPage((p) => p - 1)} className="rounded border border-border px-2 py-1 disabled:opacity-40">
            Prev
          </button>
          <span>
            Page {page} of {totalPages} · {query.data.total} entries
          </span>
          <button disabled={page >= totalPages} onClick={() => setPage((p) => p + 1)} className="rounded border border-border px-2 py-1 disabled:opacity-40">
            Next
          </button>
        </div>
      )}
    </div>
  );
}
